import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "common/hoc";
import ArtistUploadTemplate from "themes/application/producer/components/upload/ArtistUploadTemplate";

function ProducerUploadContentTemplate({ producerUploadContentViewStore, t }) {
    const { selectedProducerId, artistUploadViewStore } = producerUploadContentViewStore;

    return (
        <div>
            <h1 className="u-type--base u-mar--bottom--sml">
                Upload Content
            </h1>

            {selectedProducerId && (
                <div className="c-card--primary u-padd--med">
                    <ArtistUploadTemplate artistUploadViewStore={artistUploadViewStore} t={t} />
                </div>
            )}
        </div>
    );
}

ProducerUploadContentTemplate.propTypes = {
    producerUploadContentViewStore: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default defaultTemplate(ProducerUploadContentTemplate);
